import React, { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { Form, FormActions, FormFields, FormTextField, Stack } from "sprint-common-web";

import { useCreateFramerateProfileForm } from "./useCreateFramerateProfileForm";

export interface CreateFramerateProfileFormProps {
    onCancel(): void;
    onSubmit(): void;
}

export interface CreateFramerateProfileFormInputs {
    name: string;
    framerate2398: string;
    framerate2997: string;
    framerate24: string;
    framerate25: string;
    framerate30: string;
    framerate50: string;
    framerate5994: string;
    framerate60: string;
    framerateOther: string;
}

export const CreateFramerateProfileForm: FunctionComponent<CreateFramerateProfileFormProps> = (
    props: CreateFramerateProfileFormProps
) => {
    const { errors, control, formState, reset, handleSubmit } = useForm<CreateFramerateProfileFormInputs>({
        defaultValues: {
            name: "",
            framerate2398: "",
            framerate2997: "",
            framerate24: "",
            framerate25: "",
            framerate30: "",
            framerate50: "",
            framerate5994: "",
            framerate60: "",
            framerateOther: ""
        },
        criteriaMode: "all"
    });

    const { createFramerateProfile } = useCreateFramerateProfileForm();

    const handleCreateFramerateProfile = async (inputs: CreateFramerateProfileFormInputs) => {
        await createFramerateProfile(inputs);
        props.onSubmit();
        reset();
    };

    const handleCancelButtonClick = () => {
        reset();
        props.onCancel();
    };

    return (
        <Form onSubmit={handleSubmit(handleCreateFramerateProfile)}>
            <Stack verticalAlign="space-between">
                <FormFields>
                    <FormTextField
                        label="Name"
                        control={control}
                        name="name"
                        errors={errors}
                        rules={{
                            required: "Name is required field"
                        }}
                    />
                    <FormTextField
                        label="Framerate 23.976"
                        control={control}
                        name="framerate2398"
                        errors={errors}
                        rules={{
                            required: "Framerate 23.976 is required field"
                        }}
                    />

                    <FormTextField
                        label="Framerate 24"
                        control={control}
                        name="framerate24"
                        errors={errors}
                        rules={{
                            required: "Framerate 24 is required field"
                        }}
                    />
                    <FormTextField
                        label="Framerate 25"
                        control={control}
                        name="framerate25"
                        errors={errors}
                        rules={{
                            required: "Framerate 25 is required field"
                        }}
                    />
                    <FormTextField
                        label="Framerate 29.97"
                        control={control}
                        name="framerate2997"
                        errors={errors}
                        rules={{
                            required: "Framerate 29.97 is required field"
                        }}
                    />
                    <FormTextField
                        label="Framerate 30"
                        control={control}
                        name="framerate30"
                        errors={errors}
                        rules={{
                            required: "Framerate 30 is required field"
                        }}
                    />
                    <FormTextField
                        label="Framerate 50"
                        control={control}
                        name="framerate50"
                        errors={errors}
                        rules={{
                            required: "Framerate 50 is required field"
                        }}
                    />
                    <FormTextField
                        label="Framerate 59.94"
                        control={control}
                        name="framerate5994"
                        errors={errors}
                        rules={{
                            required: "Framerate 59.94 is required field"
                        }}
                    />
                    <FormTextField
                        label="Framerate 60"
                        control={control}
                        name="framerate60"
                        errors={errors}
                        rules={{
                            required: "Framerate 60 is required field"
                        }}
                    />
                    <FormTextField
                        label="Framerate Other"
                        control={control}
                        name="framerateOther"
                        errors={errors}
                        tooltipContent="Framerate value that does not fit in standard framerates. Works as a fallback framerate."
                        rules={{
                            required: "Framerate Other is required field"
                        }}
                    />
                </FormFields>
                <FormActions
                    isLoading={formState.isSubmitting || formState.isValidating}
                    onCancel={handleCancelButtonClick}
                />
            </Stack>
        </Form>
    );
};
